import { render, staticRenderFns } from "./SliderPollAnswers.vue?vue&type=template&id=0eda5c68&"
import script from "./SliderPollAnswers.vue?vue&type=script&lang=ts&"
export * from "./SliderPollAnswers.vue?vue&type=script&lang=ts&"
import style0 from "./SliderPollAnswers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports